import { fetchJSON, requestGet } from "../utils/network";
import { TimedCache } from "../utils/timed-cache";
import type { Prices } from "./_objects-patient";

const cache: TimedCache<string, Prices | null> = new TimedCache<
  string,
  Prices | null
>(null, 60 * 60);

export async function getPriceLinesByCache(
  date: string | null
): Promise<Prices | null> {
  if (!date) {
    return null;
  }

  const borderDates = Array.from(cache.keys());
  borderDates.sort();

  const priceDate = borderDates.filter((value) => {
    const dates = value.split("|");
    return dates[0] <= date && date < dates[1];
  })[0];

  if (priceDate && cache.get(priceDate)) {
    return cache.get(priceDate);
  }

  const response = await fetchJSON<Prices>(requestGet("/api/price", { date }));
  if (!response) {
    return null;
  }

  const price: Prices = response;
  const key = `${price.date_from}|${price.date_to}`;

  cache.set(key, price);
  return price;
}

export const devPriceCacheClear = () => cache.clear();
